import { withText } from './Text';
import { Callout } from './Text.styles';

const CalloutText = withText(Callout);

CalloutText.displayName = 'CalloutText';

export { CalloutText };
